import BaseApi from './BaseApi';

export interface ISearch {
    search(searchText: string, jwt: string): Promise<Object>;
    verifyId(context: string, id: string, jwt: string): Promise<Object>;
}

export default class Search extends BaseApi implements ISearch {
    constructor(baseUrl: string) {
        super(baseUrl);
    }

    search = (searchText: string, jwt: string) => {
        return this.getRequest(`${this.baseUrl}v1.0/search/${searchText}`, jwt);
    };

    verifyId = (context: string, id: string, jwt: string) => {
        const params = `?context=${context}&id=${id}`;
        return this.getRequest(`${this.baseUrl}v1.0/search/verify-id${params}`, jwt);
    };
}



// WEBPACK FOOTER //
// ./src/api/Search.ts